import * as numbers from "common/numbers";

export const LABEL_CELL_SX = { width: "40%" };
export const FONT_SIZE = "0.75rem";
export const COL_WIDTHS = {
  label: "auto",
  default: 80,
  override: 110,
  action: 32,
};

export const NON_SELECT_FLAG_TYPES = ["REVENUE_BAND", "MANUAL_MODIFIER"];
export const IAB_PREDICATE_KEY = "flag.IABPricing";

export const selectStoredExposures = (state) =>
  state.input?.flags?.exposures ?? [];

export const fmt = (val, dp = 3) =>
  val != null ? numbers.dpString(dp)(val) : "—";

export const fmtCurrency = (val) =>
  val != null ? numbers.currencyFormat(val, 0) : "—";

export const fmtPct = (val) =>
  val != null ? `${numbers.dpString(1)(val * 100)}%` : "—";
